<template>
  <ResourceTable class="content-block"
                 :queryFilter="queryFilter"
                 :querySorter="querySorter"
                 :queryPager="queryPager"
                 :addButton="{ name: 'resourcesNew'}"
                 :resourceStatus="$route.params.status"
                 @filter-changed="onFilterChanged"
                 @sorter-changed="onSorterChanged"
                 @pager-changed="onPageChanged"
  ></ResourceTable>
</template>

<script>
import ResourceTable from 'CORE/components/resource/table'
import PersistentQueryMixin from 'CORE/mixins/persistent-query'

export default {
    name: 'ResourcesListView',
    components: {
        ResourceTable,
    },
    mixins: [
        PersistentQueryMixin,
    ],
}
</script>
